import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { IGetServiceProps } from "@api/types/globalService.types";

export const useGetAllCattleBreedsServices = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
  cattleTypeId,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const allCattleBreedsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CATTLE_BREEDS,
      debouncedQuery,
      page,
      per_page,
      cattleTypeId,
    ],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS.CATTLE_BREEDS,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[cattle_type_id]": cattleTypeId || "",
          page,
          per_page,
          include: "cattleType",
        },
      });
    },
    enabled: enableQuery,
  });
  return {
    services: { allCattleBreedsService },
    states: { searchQuery, setSearchQuery },
  };
};

export const useGetSingleCattleBreedService = ({
  breedId,
}: {
  breedId: number;
}) => {
  const singleCattleBreedService = useQuery({
    queryKey: [CACHE_KEYS.SINGLE_CATTLE_BREEDS, breedId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.CATTLE_BREEDS}/${breedId}`,
      }),
    enabled: breedId ? true : false,
  });
  return { service: { singleCattleBreedService } };
};
